import { Observable } from 'rxjs';
import { map, shareReplay, take } from 'rxjs/operators';
import { inject } from '@angular/core';
import { userTenantFeature } from '@core/user-tenant/user-tenant.reducer';
import { Store } from '@ngrx/store';
import { notNullish } from '@app/shared/rxjs/operators/standard-operators';

export abstract class TenantBaseService {
  private readonly tenantId$ = inject(Store)
    .select(userTenantFeature.selectSelectedTenantId)
    .pipe(notNullish());
  protected readonly tenantBaseUrl$: Observable<string>;

  protected constructor(protected baseUrl: string) {
    this.tenantBaseUrl$ = this.tenantId$.pipe(
      map(tenantId => this.baseUrl + `/o/${tenantId}`),
      shareReplay(),
      take(1),
    );
  }
}
